import { useSelector } from 'react-redux'
import { HandleDetail } from '../../../../common/handleDetail'
import { VALUE_SCORE } from '../../../constant'
import { getDataTablePerRedux, getDataTableRedux } from '../../store/slice'

export const CompanyNumber = ({
  data,
  rowId,
  period,
  typeValue,
  isDynamicReport,
}) => {
  const dataRowRisk = useSelector(getDataTableRedux(rowId))
  const dataRowPer = useSelector(getDataTablePerRedux(rowId))

  const dataRow =
    typeValue === VALUE_SCORE.CREDIT_SCORE ? dataRowRisk : dataRowPer

  return (
    <HandleDetail
      path="PortfolioInsights/TrendScoreDetails"
      otherParams={{
        modelId: typeValue,
        timeFrequency: period,
        trendConfig: {
          previousLevel: dataRow?.previousLevel,
          trend: dataRow?.trend,
          currentLevel: dataRow?.currentLevel,
          modelId: typeValue,
        },
      }}
      isDynamicReport={isDynamicReport}
    >
      {data}
    </HandleDetail>
  )
}
